import React from "react";
import placeHolderImage from "./../../images/user-image-placeholder.png";
import { Colors } from "../../Constants/colors";
import { Divider } from "../Divider";
import { TextBtnType, TextButton } from "../Button/TextButton";
import { UserAvatar } from "../UserAvatar/UserAvatar";

interface Data {
  key: string;
  value: string;
}
interface Action {
  onClick: () => unknown;
  title: string;
  type: TextBtnType;
}
interface Props {
  data: Data[];
  avatar?: string;
  actions?: Action[];
}
export const ItemDetailCard = ({ data, avatar, actions = [] }: Props) => {
  const image = avatar ? avatar : placeHolderImage;
  return (
    <div
      style={{
        maxWidth: "300px",
        minHeight: "300px",
        padding: "25px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        borderRadius: "10px",
        boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
        backgroundColor: Colors.White,
      }}
    >
      <UserAvatar image={image} />
      <Divider />
      <div
        className="mt-2 flex flex-col gap-2 w-full"
        style={{
          fontSize: "14px",
        }}
      >
        {data.map(({ key, value }, index) => {
          return (
            <>
              <div className="flex flex-row">
                <p
                  style={{
                    color: Colors.DarkGrey,
                  }}
                >
                  {key} :-
                </p>
                <p
                  className="ml-1 flex-1 inline-block"
                  style={{
                    width: "150px",
                    wordWrap: "break-word",
                    color: Colors.Midgrey,
                  }}
                >
                  {value}
                </p>
              </div>
            </>
          );
        })}
      </div>

      {/* Footer */}
      <div className="w-full mt-4 flex justify-end gap-4">
        {actions.map(({ title, onClick, type }) => {
          return (
            <div>
              <TextButton type={type} title={title} onClick={onClick} />
            </div>
          );
        })}
      </div>
    </div>
  );
};
